import { useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";

export function MockupLightbox({ img, name, onOpen }: { img: string; name: string; onOpen?: () => void }) {
  const [open, setOpen] = useState(false);
  const [naturalWidth, setNaturalWidth] = useState<number | null>(null);
  return (
    <>
      <div
        className="portfolio-scroll relative h-[280px] overflow-hidden rounded-lg bg-white cursor-zoom-in"
        onClick={() => {
          if (onOpen) {
            onOpen();
            return;
          }
          if (window.matchMedia("(min-width: 768px)").matches) setOpen(true);
        }}
      >
        <img src={img} alt={`${name} website design preview`} width={1280} height={1920} loading="lazy" className="portfolio-scroll-img w-full block" />
      </div>
      {!onOpen && <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent aria-describedby={undefined} className="mockup-lightbox-dialog w-[92vw] max-w-3xl max-h-[90vh] overflow-hidden p-2 pt-12 bg-white border-none rounded-xl flex flex-col">
          <VisuallyHidden>
            <DialogTitle>{name} website design full preview</DialogTitle>
          </VisuallyHidden>
          <div className="min-h-0 flex-1 overflow-y-auto rounded-lg">
            <img
              src={img}
              alt={`${name} website design full preview`}
              onLoad={(e) => setNaturalWidth(e.currentTarget.naturalWidth)}
              style={naturalWidth ? { width: Math.min(naturalWidth, 896), maxWidth: "100%" } : { width: "100%" }}
              className="block rounded-lg mx-auto h-auto"
            />
          </div>
        </DialogContent>
      </Dialog>}
    </>
  );
}
